import { Body3 } from 'components/Typography';
import type { DynaVault } from '../../../../api/DynaVaultsAPI';
import { getVaultStatus } from 'structure/pv2/dynavault/utils/vaultStatus';
import { twMerge } from 'tailwind-merge';

interface VaultStatusProps {
  vault: Pick<DynaVault, 'isClosed' | 'vaultType'>;
  className?: string;
}

export const VaultStatus = (props: VaultStatusProps) => {
  const { vault, className } = props;
  const status = getVaultStatus(vault);

  return (
    <Body3 className={twMerge('font-normal', status.colorClass, className)}>
      {status.label}
    </Body3>
  );
};
